/* "Já, þetta er gjöf" hak við Ganga frá kaupum (körfuskúffa og körfusíða).
   Vistast sem körfueiginleiki "Gjöf" og birtist á pöntuninni undir Additional details. */
(function () {
  var KEY = 'Gjöf';
  var VAL = 'Já, þetta er gjöf';
  var state = false;

  var css = document.createElement('style');
  css.textContent = '.bb-gjof{display:flex;align-items:center;gap:1rem;margin:0 0 1.2rem;padding:1.1rem 1.4rem;background:#EDE1FF;font-size:1.4rem;line-height:1.4;cursor:pointer;color:#532029;}' +
    '.bb-gjof input{width:1.8rem;height:1.8rem;margin:0;accent-color:#532029;cursor:pointer;flex:0 0 auto;}';
  document.head.appendChild(css);

  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { state = !!(c && c.attributes && c.attributes[KEY]); })
      .catch(function () {});
  }

  function save(on) {
    state = on;
    var attrs = {};
    attrs[KEY] = on ? VAL : '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function place() {
    var btns = document.querySelectorAll('#CartDrawer-Checkout, cart-drawer button[name="checkout"], .cart__ctas button[name="checkout"], #checkout');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var host = btn.closest('.cart__ctas') || btn;
      var parent = host.parentNode;
      if (!parent) continue;
      var prev = host.previousElementSibling;
      if (prev && prev.hasAttribute('data-gjof')) {
        prev.querySelector('input').checked = state;
        continue;
      }
      var w = document.createElement('label');
      w.className = 'bb-gjof';
      w.setAttribute('data-gjof', '');
      w.innerHTML = '<input type="checkbox"><span>' + VAL + '</span>';
      var cb = w.querySelector('input');
      cb.checked = state;
      cb.addEventListener('change', function (e) {
        var on = e.target.checked;
        save(on);
        var all = document.querySelectorAll('[data-gjof] input');
        for (var k = 0; k < all.length; k++) all[k].checked = on;
      });
      parent.insertBefore(w, host);
    }
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; place(); });
  }

  load().then(function () {
    place();
    if (window.MutationObserver) {
      new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    }
  });
})();
